/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The volume unit:
 *   * KG
 *   * L
 *   * G
 *   * M3
 *   * WH
 */
export enum VolumeUnit {
  KG = 'KG',
  L = 'L',
  G = 'G',
  M3 = 'M3',
  WH = 'WH'
}
